// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".more-actions_icon__fKma0 {\n  display: flex;\n  align-items: center;\n}\n\n.more-actions_icon__fKma0 svg:first-child {\n  width: 20px;\n  height: 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/atoms/icons/more-actions/more-actions.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".icon {\n  display: flex;\n  align-items: center;\n}\n\n.icon svg:first-child {\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "more-actions_icon__fKma0"
};
export default ___CSS_LOADER_EXPORT___;
